/*
 *
 * MultiMerchantSelect
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 20-Nov-2024
 */

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import MultiMerchantSelect from './MultiMerchantSelect'
import * as actionLayer from 'Store/actions/user'
import { createSelector } from 'reselect'
import { getUserRoles } from 'Store/selectors'

const getNormalizedRoleName = (role) => (role.name.startsWith('NB') ? role.name.replace('NB', '') : role.name)

export const getMultiRoles = createSelector([getUserRoles], (roles) =>
  roles.length > 1
)

export const getSubRole = createSelector([getUserRoles], (roles) => 
  roles.some((role) => getNormalizedRoleName(role).includes('admin_'))
)

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(actionLayer, dispatch)
})

const mapStateToProps = (state) => ({
  merchantId: state.user?.userProfile?.merchant?.merchantId || '',
  businessName: state.user?.userProfile?.merchant?.businessName || '',
  merchantGroup: state.user?.userProfile?.merchantGroup || [],
  loading: state.loading?.local_searchUserProfile || false,
  userProfileList: state.user?.userProfile?.user?.roles || [],
  hasSwitchableMerchants: state.user?.hasSwitchableMerchants,
  hasMultiRole: getMultiRoles(state) || false,
  hasSubRole: getSubRole(state) || false,
  search: state.user?.merchantSearch || ''
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(MultiMerchantSelect)
